import ajax from "../../lib/appfuse-react/core/ajax";

const enrollmentService = {
    findAgreement: async () => {
        const response = await ajax.get('enrollments/personalInformationAgreement');
        return response.data;
    },

    validEnrollment: async (data) => {
        await ajax.post('enrollments/validateEnrolled', data);
    },

    validate: async (data) => {
        const response = await ajax.post('enrollments/validate', data);
        return response.data;
    },
    enrollment: async (data) => {
        const response = await ajax.post('enrollments', data);
        return response.data;
    },

    validateWaiting: async (data) => {
        const response = await ajax.post('waitingLists/validate', data);
        return response.data;
    },
    waiting: async (data) => {
        const response = await ajax.post('waitingLists', data);
        return response.data;
    },

    allWaiting: async (courseClassUuid) => {
        const response = await ajax.get(`courseClasses/${courseClassUuid}/allWaiting`);
        return response.data;
    },
}

export default enrollmentService;